import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  DEFAULT_RENDER_CONFIG,
  getRenderConfigSummaryItems,
  normalizeRenderConfig,
} from "../store/renderConfig";
import { saveReportRenderSetting } from "../store/actions/defaultAction";
import useReportRenderSettingLoader from "./useReportRenderSettingLoader";

export const useReportPresentation = ({ reportTypeId, columnDefinitions }) => {
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => state.authReducer);
  const { organizationId, savingReportRenderSetting } = useSelector(
    (state) => state.defaultReducer
  );
  const [renderConfig, setRenderConfig] = useState(DEFAULT_RENDER_CONFIG);
  const options = useMemo(() => ({ columnDefinitions }), [columnDefinitions]);
  const effectiveRenderConfig = useMemo(
    () => normalizeRenderConfig(renderConfig, options),
    [renderConfig, options]
  );
  const presentationSummaryItems = useMemo(
    () => getRenderConfigSummaryItems(effectiveRenderConfig, options),
    [effectiveRenderConfig, options]
  );
  const isLoadingRenderSetting = useReportRenderSettingLoader({
    userId: userData?.id,
    organizationId,
    reportTypeId,
    renderConfigOptions: options,
    setRenderConfig,
  });

  const saveRenderConfig = () => {
    dispatch(
      saveReportRenderSetting({
        userId: userData.id,
        organizationId,
        reportTypeId,
        renderConfig: effectiveRenderConfig,
      })
    );
  };

  return {
    effectiveRenderConfig,
    isLoadingRenderSetting,
    isSaving: savingReportRenderSetting,
    presentationSummaryItems,
    saveRenderConfig,
    setRenderConfig,
  };
};
